import axios from 'axios';
import axiosInstance from '../../../../app/myAxiosInstance';

const pmsBaseApiUrl = process.env.REACT_APP_HOST + process.env.REACT_APP_BASE_API_URL;

const beatsBaseApiUrl = process.env.REACT_APP_BEATS_HOST;

const axiosInstanceBeats = axios.create({
    headers: {
        'API_KEY': process.env.REACT_APP_BEATS_API_KEY,
    }
});

export const TokenPaymentsServices =

{
    getTokenListingList: async (data) => {
        let result;
        try {

            console.log(`${beatsBaseApiUrl}/api/v1/Pms/GetTokenListingList`);
            result = await axiosInstanceBeats.post(`${beatsBaseApiUrl}/api/v1/Pms/GetTokenListingList`, data);
        } catch (err) {
            result = err;
            console.error('error in GetTokenListingList ', err);
        }
        return result;
    },

    getTokenPaymentDetails: async (data) => {
        let result;
        try {

            result = await axiosInstanceBeats.post(`${beatsBaseApiUrl}/api/v1/pms/GetTokenPaymentDetails`, data);
        } catch (err) {
            result = err;
            console.error('error in GetTokenPaymentDetails ', err);
        }
        return result;
    },


    getHouseByListingId: async (listingId) => {
        try {
            const result = await axiosInstance.get(`${pmsBaseApiUrl}admin/houses`, {
                params: { beatsListingIdentifier: listingId, scope: 'ALL', include: ['LATEST_LEASE'], offset: 0, limit: 1 }
            });
            return result?.data?.houses?.[0] || null;
        } catch (err) {
            console.error('error in getHouseByListingId ', err);
            return null;
        }
    },

    openFile: async (fileUrl) => {
        if (!fileUrl) return;
        try {
            const result = await axiosInstance.get(`${pmsBaseApiUrl}admin/beatsFiles/getPreSignedFileUrl`, { params: { unsignedFileUrl: fileUrl } });
            if (result?.data?.status === 1 && result?.data?.filePath) {
                window.open(result.data.filePath, '_blank');
            } else {
                alert('Unable to generate file URL');
            }
        } catch (err) {
            console.error('error in getPreSignedFileUrl ', err);
            alert('Unable to open file');
        }
    }
};
